import {FC, useLayoutEffect} from "react";
import {Outlet} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {getNavigateToUri} from "modules/selectors";
import {setRedirectUri} from "modules/actions";
import {useURLQuery} from "modules/utils";

export const NavigateLayout: FC = () => {
	const dispatch = useDispatch();
	const navigateToUri = useSelector(getNavigateToUri);
	const params = useURLQuery();
	const redirectUri = params.get("redirectUri");

	// Move the user to a new page. If the root starts with "/",
	// then the navigation will be within the domain.
	useLayoutEffect(() => {
		if (!navigateToUri) {
			return;
		}

		window.location.href = navigateToUri;
	}, [navigateToUri]);

	// redirectUri is taken from the query params, and is placed in the reducer,
	// if the redirectUri is updated, it will be updated in the reducer as well.
	// It is clear when the page is reloaded (trigger navigateTo) or is trigger of the setRedirectUri
	useLayoutEffect(() => {
		if (redirectUri) {
			dispatch(setRedirectUri(redirectUri));
		}
	}, [dispatch, redirectUri]);

	return <Outlet />;
};
